import type { ReactNode } from "react";
import { ArrowRight } from "lucide-react";
import type { Account, Payee, Transaction, Trip } from "../../../types";
import type { TransactionFilters } from "../../../app/views";
import Empty from "../../../components/Empty";
import TransactionRow from "../../../components/TransactionRow";

export default function LatestActivity({
  monthTransactions, accounts, payees, trips, trackedCounts, collapsed, collapseButton, setDetail, showTransactions,
}: {
  monthTransactions: Transaction[];
  accounts: Account[];
  payees?: Payee[];
  trips?: Trip[];
  trackedCounts: Map<string, number>;
  collapsed: boolean;
  /** The module's collapse toggle, drawn by the caller so every module's matches. */
  collapseButton: ReactNode;
  setDetail: (t: Transaction | null) => void;
  showTransactions: (filters: TransactionFilters) => void;
}) {
  return (
    <section className={`panel activity-panel overview-module${collapsed ? " is-collapsed" : ""}`}>
      <div className="section-heading">
        <div>
          <h2>Latest activity</h2>
          <p>The most recent ins & outs</p>
        </div>
        <div className="overview-heading-actions"><button
          className="text-button"
          onClick={() => showTransactions({})}
        >
          View all <ArrowRight size={15} />
        </button><span className="collapsed-summary">{Math.min(5, monthTransactions.length)} recent</span>{collapseButton}</div>
      </div>
      {monthTransactions.length ? (
        monthTransactions
          .slice(0, 5)
          .map((t) => (
            <TransactionRow
              key={t.id}
              t={t}
              accounts={accounts}
              payees={payees}
              trips={trips}
              trackedCount={trackedCounts.get(t.id) || 0}
              onClick={() => setDetail(t)}
            />
          ))
      ) : (
        <Empty
          title="Nothing here yet"
          description="Your transactions for this month will appear here."
        />
      )}
    </section>
  );
}
